<template>
  <div>

  </div>
</template>

<script>
export default {
    metaInfo: {
    title: 'Easy Tailor App - Help and Support Documents',
    htmlAttrs: {
      lang: 'en',
      amp: true
    }
  },
  mounted() {
        window.location = 'https://reachus.easytailorapp.com'
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Help/Index.vue